/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BannerCreateRequest = {
    bootCampCategory?: BannerCreateRequest.bootCampCategory;
    type?: BannerCreateRequest.type;
    title?: string;
    sequence?: number;
    pcImage?: Blob;
    mobileImage?: Blob;
    forwardLink?: string;
    displayStartAt?: string;
    displayEndAt?: string;
    hide?: boolean;
};

export namespace BannerCreateRequest {

    export enum bootCampCategory {
        ALL = 'ALL',
        SEBFE = 'SEBFE',
        SEBBE = 'SEBBE',
        UUB = 'UUB',
        GMB = 'GMB',
        DOB = 'DOB',
        PMB = 'PMB',
        BEB = 'BEB',
        AIB = 'AIB',
    }

    export enum type {
        HERO = 'HERO',
        POPUP = 'POPUP',
    }


}

